/** Format lap time in ms → M:SS.mmm */
export function formatTime(ms: number): string {
  if (!ms || ms <= 0) return '—';
  const totalSec = ms / 1000;
  const min = Math.floor(totalSec / 60);
  const sec = totalSec % 60;
  return `${min}:${sec.toFixed(3).padStart(6, '0')}`;
}

/** Format delta in ms → +X.XXX or ±0.000 */
export function formatDelta(ms: number): string {
  if (ms === 0) return '±0.000';
  const sign = ms > 0 ? '+' : '−';
  return `${sign}${Math.abs(ms / 1000).toFixed(3)}`;
}

/** Format total track time (ms) → Xh Ym */
export function formatTrackTime(ms: number): string {
  if (!ms) return '0m';
  const totalMin = Math.floor(ms / 60000);
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}

/** Format sector time in ms → SS.mmm */
export function formatSector(ms: number): string {
  if (!ms || ms <= 0) return '—';
  return (ms / 1000).toFixed(3);
}

/** Convert raw speed (×10) to km/h */
export function rawSpeed(v: number): number { return v / 10; }

/** Convert raw temp (×10) to °C */
export function rawTemp(v: number): number { return v / 10; }

/** Convert raw gforce (1000 = 0G, 100 units = 1G) → G */
export function rawG(v: number): number { return (v - 1000) / 100; }

/** Convert raw lat/lon to degrees */
export function rawCoord(v: number): number { return v / 1000000; }

/** Escape HTML to prevent XSS */
export function esc(s: string | null | undefined): string {
  const d = document.createElement('div');
  d.textContent = s ?? '';
  return d.innerHTML;
}

/** Weather condition emoji */
export function weatherIcon(condition: string): string {
  const icons: Record<string, string> = {
    CLEAR: '☀️', PARTLY_CLOUDY: '⛅', OVERCAST: '☁️', CLOUDY: '☁️',
    FOG: '🌫️', DRIZZLE: '🌦️', LIGHT_RAIN: '🌧️', RAIN: '🌧️',
    HEAVY_RAIN: '🌧️', SNOW: '❄️', THUNDERSTORM: '⛈️',
  };
  return icons[condition] || '🌡️';
}

/** Format date for display: DD.MM.YYYY HH:MM */
export function formatDateTime(dateStr: string): string {
  const d = new Date(dateStr);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  return `${day}.${month}.${year} ${hours}:${minutes}`;
}

/** Format date short: DD.MM.YYYY */
export function formatDate(dateStr: string): string {
  const d = new Date(dateStr);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
}

/** Format time only: HH:MM */
export function formatTimeOfDay(dateStr: string): string {
  const d = new Date(dateStr);
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
}
